import deepmerge from "deepmerge";
import Brands, {ThemeConfig} from "./types";
import base from "./base";
import {BaseTheme} from "./base/types";

export const createBrandTheme = <
  TBrand extends Brands,
  TTheme extends ThemeConfig<TBrand>
>(
  brandTheme: TTheme
): BaseTheme & TTheme => deepmerge<BaseTheme, TTheme>(base, brandTheme);
